import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, RedirectRequest } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { IUserProfile } from '../../shared/interfaces/user-profile';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private userSubject = new BehaviorSubject<IUserProfile | null>(null);
  user$ = this.userSubject.asObservable();
  constructor(private msal: MsalService) {
    this.initializeUser();
  }

  private initializeUser(): void {
    const account = this.msal.instance.getActiveAccount() || this.msal.instance.getAllAccounts()[0];

    if (!account) {
      return;
    }

    this.msal.instance.setActiveAccount(account);
    this.setUserFromAccount(account);
  }

  private setUserFromAccount(account: AccountInfo): void {
    const claims = account.idTokenClaims as any;
    const user: IUserProfile = {
      email: claims.preferred_username || claims.email || claims.upn || '',
      name: claims.name || '',
    };

    this.userSubject.next(user);
  }

  get user(): IUserProfile | null {
    return this.userSubject.value;
  }

  login(): void {
    const request: RedirectRequest = {
      scopes: environment.azure.graphScopes,
    };
    this.msal.loginRedirect(request);
  }

  logout(): void {
    this.msal.logoutRedirect();
  }

  get account(): AccountInfo | null {
    return this.msal.instance.getActiveAccount() || this.msal.instance.getAllAccounts()[0] || null;
  }

  get isLoggedIn(): boolean {
    return !!this.account;
  }

  getTokenSilent(scopes: string[] = environment.azure.graphScopes) {
    const account = this.account;
    if (!account) {
      return Promise.reject('No account available');
    }
    return this.msal.acquireTokenSilent({ scopes, account });
  }
}
